import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Accordion, type AccordionProps } from '@/app/components/text-and-data-display/accordion';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
interface CustomSelectionProps extends AccordionProps {
  selectedValue?: React.ReactNode;
}
export const CustomSelection = t0 => {
  const $ = _c(13);
  const {
    isOpen: t1,
    onChange,
    content,
    title: t2,
    value,
    selectedValue,
    test: t3
  } = t0;
  const isOpen = t1 === undefined ? false : t1;
  const title = t2 === undefined ? "" : t2;
  const test = t3 === undefined ? "custom-selection" : t3;
  let t4;
  if ($[0] !== content || $[1] !== isOpen || $[2] !== onChange || $[3] !== title || $[4] !== value) {
    t4 = <Accordion className="text-body-1-fixed p-0 hover:bg-white focus:bg-white" contentClassName="p-0 pt-2" isOpen={isOpen} onChange={onChange} content={content} theme="light" title={title} value={value} />;
    $[0] = content;
    $[1] = isOpen;
    $[2] = onChange;
    $[3] = title;
    $[4] = value;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isOpen || $[7] !== selectedValue || $[8] !== test) {
    t5 = !isOpen && <div className="flex justify-between gap-x-6" {...createDataAttributes({
      test: `selected-${test}`
    })}>{selectedValue ?? ""}</div>;
    $[6] = isOpen;
    $[7] = selectedValue;
    $[8] = test;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="cursor-pointer space-y-2">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};